module.exports = __webpack_public_path__ + "static/media/github-logo.b53ff55e.svg";